import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import sidebarReducer from './sidebarSlice';
import payslipReducer from './slices/payslipSlice';
import bankReducer from './slices/bankSlice';
import additionalDetailsReducer from './slices/additionalDetailsSlice';
import gameTestingReducer from './slices/gameTestingSlice';
import bugResolutionReducer from './slices/bugResolutionSlice';
import claimManagementReducer from './slices/claimManagementSlice';
import leaveManagementReducer from './slices/leaveManagementSlice';
import approvalsReducer from './slices/approvalsSlice';
import employeeManagementReducer from './slices/employeeManagementSlice';
import taskManagementReducer from './slices/taskManagementSlice';
import notificationReducer from './slices/notificationSlice';
import performanceReviewReducer from './slices/performanceReviewSlice';
import advisorsReducer from './slices/advisorsSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import bugsAssignedReducer from './slices/bugsAssignedSlice';
import registrationReducer from './slices/registrationSlice';
import recruitmentReducer from './slices/recruitmentSlice';

// Configure persistence for auth slice only
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['isAuthenticated', 'userType', 'user', 'isAdmin', 'adminViewActive', 'canAssessRecruitment'], // persist these fields
};

// Combine reducers
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  ui: uiReducer,
  sidebar: sidebarReducer,
  payslips: payslipReducer,
  bank: bankReducer,
  additionalDetails: additionalDetailsReducer,
  gameTesting: gameTestingReducer,
  bugResolution: bugResolutionReducer,
  bugsAssigned: bugsAssignedReducer,
  claimManagement: claimManagementReducer,
  leaveManagement: leaveManagementReducer,
  approvals: approvalsReducer,
  employeeManagement: employeeManagementReducer,
  taskManagement: taskManagementReducer,
  notifications: notificationReducer,
  performanceReview: performanceReviewReducer,
  advisors: advisorsReducer,
  subscriptions: subscriptionReducer,
  registration: registrationReducer,
  recruitment: recruitmentReducer,
});

// Create store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Create persisted store
export const persistor = persistStore(store);

export default store; 